import { FiSearch } from 'react-icons/fi';
import {
  MdClose,
  MdFilterList,
  MdOutlineArrowDownward,
  MdSettings,
} from 'react-icons/md';
import styled from 'styled-components';

const TableHeader = styled.div`
  display: flex;
  height: 60px;
  width: 100%;
  padding: 16px 0px 18px 0px;
  border-radius: 3px 3px 0 0;
  align-items: center;
  box-sizing: border-box;
  margin: 12px auto;
`;

const TableTitle = styled.div`
  display: flex;
  width: 50%;
  font-size: 17px;
  color: #635f6c;
`;

const TableFilterIcons = styled.div`
  display: flex;
  justify-content: flex-end;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.2px;
  text-align: left;
  cursor: pointer;
  margin-left: auto;

  > svg,
  span > svg {
    margin: 0 10px;
    color: #888888;
    transition: color 0.1s ease-in-out;
    @media (hover: hover) {
      &:hover,
      &.active {
        color: ${({ theme }) => theme.COLOR_TABLE_DARK};
      }
    }
  }
  align-items: center !important;
`;

const Section = styled.div`
  align-items: center;
  color: ${({ theme }) => theme.COLOR_GREY_TEXT};
  background-color: #fff;
  padding: 8px 12px;
  margin: 4px;
  display: flex;
  border: 1px solid #eaedf3;
  border-radius: 4px;
  &:hover,
  &.active {
    color: ${({ theme }) => theme.COLOR_TABLE_DARK};
  }
  align-items: center !important;

  svg {
    margin: 0 6px 0 0;
  }
`;

const DropDownHolder = styled.span`
  position: relative;
  margin: 0;
  display: flex;
`;
const DropDown = styled.div`
  position: absolute;
  width: ${(props) => (props.width ? props.width : '600px')};
  top: 100%;
  right: 0;
  background-color: white;
  margin: 0;
  opacity: ${(props) => (props.open ? '1' : '0')};
  display: ${(props) => (props.open ? 'block' : 'none')};
  height: auto;
  overflow: ${(props) => (props.open ? 'visible' : 'hidden')};
  transition: opacity 0.15s ease-in-out;
  z-index: 1000;
  @media (max-width: 1000px) {
    width: ${(props) => (props.width ? props.width : '300px')};
  }
`;

const DropDownDismiss = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`;

const DropDownContent = styled.div`
  height: 100%;
  max-height: 75vh;
  background-color: white;
  border-radius: 4px;
  padding: 15px;
  border: 2px solid #e3e3e3;
  z-index: 1000;
  overflow-y: auto;
  .body {
    height: 100%;
    overflow-y: auto;
    max-height: 40vh;
  }
`;

const FilterListIcon = styled(MdFilterList)`
  font-size: 20px;
  cursor: pointer;
`;

const SettingIcon = styled(MdSettings)`
  font-size: 20px;
  cursor: pointer;
`;

const TableFiltersDiv = styled.div`
  text-align: left;
  margin-bottom: 15px;
`;

const DivDropdown = styled.div`
  margin-top: -4px;
`;

const SearchIcon = styled(FiSearch)`
  font-size: 20px;
  cursor: pointer;
`;

const ArrowDownIcon = styled(MdOutlineArrowDownward)`
  font-size: 20px;
`;

const CloseIcon = styled(MdClose)`
  cursor: pointer;
  width: 1.2em;
  height: 1.2em;
`;

const StyledTableHeader = {
  TableHeader,
  TableTitle,
  TableFilterIcons,
  Section,
  DropDownHolder,
  DropDown,
  DropDownDismiss,
  DropDownContent,
  FilterListIcon,
  SettingIcon,
  TableFiltersDiv,
  DivDropdown,
  SearchIcon,
  ArrowDownIcon,
  CloseIcon,
};

export default StyledTableHeader;
